import { useAttendeeStatus } from 'amazon-chime-sdk-component-library-react';
import classNames from 'classnames';
import React from 'react';
import { MicrophoneDisabled, Desktop } from 'wix-ui-icons-common';
import { MicrophoneMuted, ScreenShare } from '../../../../icons';
import { useVideoConfig } from '../../../video-config-provider';
import s from './indicators.scss';
export const Indicators = ({ attendeeId }) => {
    const { mobile, dashboard } = useVideoConfig();
    const { muted, sharingContent } = useAttendeeStatus(attendeeId);
    return (React.createElement("div", { className: classNames(s.container, { [s.mobile]: mobile }) },
        muted && React.createElement("div", { className: s.icon }, dashboard ? React.createElement(MicrophoneDisabled, null) : React.createElement(MicrophoneMuted, null)),
        sharingContent && React.createElement("div", { className: s.icon }, dashboard ? React.createElement(Desktop, null) : React.createElement(ScreenShare, null))));
};
//# sourceMappingURL=indicators.js.map